import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-edi-destinations',
  templateUrl: './edi-destinations.component.html',
  styleUrls: ['./edi-destinations.component.css']
})
export class EdiDestinationsComponent implements OnInit {
    public itemsListEdiDestinations: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadEdiDestinations() {
        this.itemsListEdiDestinations = await this.datatask.Post(987);
    }

    private async init() {
        this.loadEdiDestinations();
    }

    ngOnInit() {
        this.init();
    }
}
